import React from 'react';
import Button from './ui/Button';
import Reveal, { RevealGroup } from './ui/Reveal';
import SectionLabel from './ui/SectionLabel';
import actionHref from '../lib/links';
import { beginning } from '../data/content';

/** The brief's closing section, ending on its three calls to action. */
export default function Beginning() {
  return (
    <section className="bg-cream py-24 sm:py-32">
      <div className="shell flex flex-col items-center text-center">
        <Reveal variant="fade">
          <SectionLabel index="08" align="center">
            The Beginning
          </SectionLabel>
        </Reveal>

        <Reveal
          as="h2"
          delay={80}
          className="mt-7 font-display text-[2rem] font-semibold uppercase leading-[1.06] tracking-[0.01em] text-ink sm:text-4xl lg:text-[3.25rem]"
        >
          {beginning.title}
        </Reveal>
        <Reveal variant="rule" delay={240} className="rule mt-6" />

        <Reveal as="p" delay={300} className="mt-8 max-w-2xl text-base leading-relaxed text-ink/75">
          {beginning.body}
        </Reveal>
        <Reveal as="p" delay={360} className="mt-4 max-w-2xl text-base leading-relaxed text-ink/75">
          {beginning.direction}
        </Reveal>

        <RevealGroup
          as="ul"
          variant="up"
          stagger={130}
          delay={120}
          className="mt-12 flex flex-wrap justify-center gap-x-10 gap-y-4"
        >
          {beginning.words.map((word) => (
            <li key={word} className="font-display text-xl font-semibold uppercase tracking-[0.12em] text-gold-700 sm:text-2xl">
              {word}
            </li>
          ))}
        </RevealGroup>

        <Reveal as="p" delay={160} className="mt-12 max-w-2xl text-base leading-relaxed text-ink/75">
          {beginning.reach}
        </Reveal>

        <Reveal
          as="p"
          delay={220}
          className="mt-12 font-display text-2xl font-semibold uppercase tracking-[0.04em] text-ink sm:text-[2rem]"
        >
          {beginning.invite}
        </Reveal>

        <RevealGroup
          variant="up"
          stagger={110}
          delay={120}
          className="mt-9 flex flex-wrap justify-center gap-4"
        >
          {beginning.ctas.map((cta) => (
            <Button
              key={cta.label}
              href={cta.href || actionHref(cta.action)}
              variant={cta.variant}
              size="lg"
              arrow={cta.variant === 'gold'}
            >
              {cta.label}
            </Button>
          ))}
        </RevealGroup>
      </div>
    </section>
  );
}
